module.exports = __webpack_public_path__ + "img/linkedin.76ecca7e.svg";